const environment = process.env.REACT_APP_STAGE || 'dev';

function trackEvent(event, params) {
	if (environment === 'prod') {
		window.mixpanel.track(event, params);
	}
}

export default trackEvent;
